import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class ScoringExamToggle extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      onChange,
      value,
    } = this.props;

    return (
      <div className="onboarding-scoringexam-test-selector">
        <div className="onboarding-scoringexam-test-toggle">
          <div className={`onboarding-scoringexam-test-toggle-left ${value != null && (value ? 'onboarding-scoringexam-test-toggle-active' : '')}`}
            onClick={() => onChange(true)}>
            Yes
          </div>
          <div className={`onboarding-scoringexam-test-toggle-right ${value != null && (value ? '' : 'onboarding-scoringexam-test-toggle-active')}`}
            onClick={() => onChange(false)}>
            No
          </div>
        </div>
      </div>
    );
  }
}

class ScoringExam extends Component {
  constructor(props) {
    super(props);

    const {
      scoringExam,
    } = props;

    this.state = {
      selectedSkill: null,
      selectedGuidelines: true,
      examSelections: Object.fromEntries(Object.entries(scoringExam.skillTests).map(([skillId, tests]) =>
        [skillId, Object.fromEntries(tests.map(test => [test[0], null]))]
      )),
      freeExamSelections: Object.fromEntries(Object.entries(scoringExam.freeTests).map(([id, _]) => [id, []])),
      examComments: Object.fromEntries(Object.entries(scoringExam.skillTests).map(([skillId, tests]) =>
        [skillId, Object.fromEntries(tests.map(test => [test[0], '']))]
      )),
      freeExamComments: Object.fromEntries(Object.entries(scoringExam.freeTests).map(([id, _]) => [id, ''])),
    };

  }

  renderGuidelines() {
    const {
      scoringExam,
    } = this.props;
    return (
      <React.Fragment>
        <div className="onboarding-biglabel onboarding-scoringexam-title">
          <div className="onboarding-label onboarding-scoringexam-title-primary">
            Guidelines
          </div>
        </div>
        <iframe className="onboarding-scoringexam-doc" src={scoringExam.guidelinesLink}></iframe>
      </React.Fragment>
    );
  }

  renderFreeStatements() {
    const {
      scoringExam,
    } = this.props;
    const {
      freeExamSelections,
      freeExamComments,
    } = this.state;
    const tests = scoringExam.freeTests;
    return (
      <React.Fragment>
        <div className="onboarding-biglabel onboarding-scoringexam-title">
        <div className="onboarding-label onboarding-scoringexam-title-primary">Free Statements</div>
          <div className="onboarding-label onboarding-scoringexam-header">Comments</div>
          <div className="onboarding-label onboarding-scoringexam-header onboarding-label onboarding-scoringexam-header-present">What skills are present?</div>
        </div>
        {
          Object.entries(tests).map(([id, content]) => {
            const selections = freeExamSelections[id];
            return (<div className="onboarding-scoringexam-test" key={id}>
              <div className="onboarding-scoringexam-test-content">
                {content}
              </div>
              <div className="onboarding-scoringexam-test-skills">
                {
                  Object.entries(scoringExam.skills).map(([skillId, name]) => {
                    const selected = selections.includes(skillId);
                    return (
                    <div className={`onboarding-scoringexam-test-skill ${selected ? 'onboarding-scoringexam-test-skill-active' : ''}`} key={skillId}
                      onClick={() => this.setState({ freeExamSelections: { ...freeExamSelections, [id]: selected ? selections.filter(x => x != skillId) : [...selections, skillId] } })}>
                      {name}
                    </div>);
                  })
                }
              </div>
              <textarea className="onboarding-scoringexam-test-textarea" value={freeExamComments[id]} onChange={(e) => this.setState({ freeExamComments: { ...freeExamComments, [id]: e.target.value } })} />
            </div>);
          })
        }
      </React.Fragment>
    );
  }

  renderSkills(skillId) {
    const {
      scoringExam,
    } = this.props;
    const {
      examSelections,
      examComments,
    } = this.state;
    const tests = scoringExam.skillTests[skillId];
    const selections = examSelections[skillId];
    const comments = examComments[skillId];
    return (
      <React.Fragment>
        <div className="onboarding-biglabel onboarding-scoringexam-title">
          <div className="onboarding-label onboarding-scoringexam-title-primary">{scoringExam.skills[skillId]}</div>
          <div className="onboarding-label onboarding-scoringexam-header">Comments</div>
          <div className="onboarding-label onboarding-scoringexam-header onboarding-label onboarding-scoringexam-header-present">Is the skill present?</div>
        </div>
        {
          tests.map((test) => {
            const selection = selections[test[0]];
            return (<div className="onboarding-scoringexam-test" key={test[0]}>
              <div className="onboarding-scoringexam-test-content">
                {test[1]}
              </div>
              <ScoringExamToggle onChange={(value) => this.setState({ examSelections: { ...examSelections, [skillId]: { ...selections, [test[0]]: value }} })} value={selection} />
              <textarea className="onboarding-scoringexam-test-textarea" value={comments[test[0]]} onChange={(e) => this.setState({ examComments: { ...examComments, [skillId]: { ...comments, [test[0]]: e.target.value } } })} />
            </div>);
          })
        }
      </React.Fragment>
    );
  }

  renderTabBody() {
    const {
      selectedSkill,
      selectedGuidelines,
    } = this.state;
    if (selectedSkill == null && selectedGuidelines) {
      return this.renderGuidelines();
    } else if (selectedSkill == null && !selectedGuidelines) {
      return this.renderFreeStatements();
    } else {
      return this.renderSkills(selectedSkill);
    }
  }

  async onSubmit() {
    const {
      updateOnboardingStep,
    } = this.props;

    const {
      examSelections,
      freeExamSelections,
      examComments,
      freeExamComments,
    } = this.state;

    if (Object.values(examSelections).some(tests => Object.values(tests).some(value => value === null))) {
      alert('Please fill out all test entries!');
      return;
    }

    if (Object.values(examComments).some(tests => Object.values(tests).some(value => value === '')) ||
        Object.values(freeExamComments).some(value => value === '')) {
        alert('Please add comments to all test entries explaining your choices.');
        return;
    }

    const skillAnswers = Object.fromEntries(Object.entries(examSelections).map(([skillId, tests]) => {
      const comments = examComments[skillId];
      return [skillId, Object.entries(tests).map(([eventId, answer]) => ({
        event_id: parseInt(eventId),
        comment: comments[eventId],
        has_skill: answer,
      }))];
    }));

    const freeAnswers = Object.entries(freeExamSelections).map(([eventId, answer]) => ({
      event_id: parseInt(eventId),
      comment: freeExamComments[eventId],
      skill_ids: answer.map(i => parseInt(i)),
    }));

    const response = await sendAPIRequest(`/onboarding/submit_scoring_exam`, "POST", { skillAnswers, freeAnswers });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else if (response.data.status == 'failure') {
      this.setState({ failure: true });
    } else {
      throw new Error("invalid status for scorer quiz submission: " + response.data.status)
    }
  }

  render() {
    const {
      scoringExam,
    } = this.props;
    const {
      selectedSkill, // set if a skill (not guidelines or free statements) is selected
      selectedGuidelines, // true if guidelines is selected, false if free statements -- always false if selectedSkill is not null
    } = this.state;

    return (
      <div className="onboarding-scoringexam-container">
        <div className="onboarding-title">
          Scoring Exam
        </div>
        <div className="onboarding-scoringexam-tab-container">
          <div className="onboarding-scoringexam-tab-body">
            { this.renderTabBody() }
          </div>
          <div className="onboarding-scoringexam-tab-footer">
            <div className={`onboarding-scoringexam-tab-button onboarding-scoringexam-tab-button-left ${selectedGuidelines && selectedSkill == null ? 'onboarding-scoringexam-tab-button-active' : ''}`}
              onClick={() => this.setState({ selectedSkill: null, selectedGuidelines: true })}>
              Guidelines
            </div>
            {
              Object.entries(scoringExam.skills).map(([id, name], i) =>
                <div key={id} className={`onboarding-scoringexam-tab-button ${selectedSkill == id ? 'onboarding-scoringexam-tab-button-active' : ''}`}
                  onClick={() => this.setState({ selectedSkill: id, selectedGuidelines: false })}>
                  {`Skill ${i + 1}`}
                </div>
              )
            }
            <div className={`onboarding-scoringexam-tab-button onboarding-scoringexam-tab-button-right ${!selectedGuidelines && selectedSkill == null ? 'onboarding-scoringexam-tab-button-active' : ''}`}
              onClick={() => this.setState({ selectedSkill: null, selectedGuidelines: false })}>
              Free Statements
            </div>
          </div>
        </div>
        <div className="onboarding-scoringexam-submission">
          <Button className="onboarding-submission-button" text="Submit Test" onClick={() => this.onSubmit()} />
        </div>
      </div>
    );
  }

}

export default ScoringExam;
